export const apiRequest = (actionName) => `${actionName}_PENDING`;
export const apiSuccess = (actionName) => `${actionName}_SUCCESS`;
export const apiFailure = (actionName) => `${actionName}_FAILURE`;
